// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"818":"auth","826":"index"}[chunkId] + "." + {"818":"26e63a3b","826":"c456b559"}[chunkId] + ".js";
};